/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import useStyles from 'isomorphic-style-loader/useStyles';
import React, { useState } from 'react';
import { Button, Modal, Form, Input, Typography, Col, Row, notification } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import Text from 'antd/lib/typography/Text';
import axios from 'axios';
import { endpoints } from '@source/config';
import s from './index.css';

const labels = {
  eng: {
    title: 'Change Password',
    oldPassword: 'Current Password',
    newPassword: 'New Password',
    confirmationPassword: 'Confirm New Password',
    errorMsg: {
      oldPassword: 'Please enter Current Password!',
      newPassword: 'Please enter New Password!',
      confirmationPassword: 'Please Confirm New Password!',
    }
  },
  ind: {
    title: 'Ubah Password',
    oldPassword: 'Password Lama',
    newPassword: 'Password Baru',
    confirmationPassword: 'Konfirmasi Password Baru',
    errorMsg: {
      oldPassword: 'Password Lama harus diisi!',
      newPassword: 'Password Baru harus diisi!',
      confirmationPassword: 'Konfirmasi Password Baru harus diisi!',
    }
  }
}

const changePass = (token, lang, userId, body) => {
  const isEng = lang === 'eng';
  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    }
  };
  const url = `${endpoints.api}be/api/users/password/update?isEng=${isEng}&usersId=${userId}`;
  return axios.put(url, body, config);
};

export default function ModalChangePassword(props) {
  const { onCancel, onFinish, token, language, userData } = props;
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const label = labels[language];
  useStyles(s);

  const handleLogin = value => {
    form.validateFields().then(async val => {
      setLoading(true);
      try {
        const res = await changePass(token, language, userData.userId, val);
        if (res.data.responseType !== 'Success') {
          throw res.data;
        }
        notification.success({
          message: 'Success',
          description: res.data.message,
          placement: 'bottomRight'
        });
        onFinish();
      } catch (err) {
        notification.error({
          message: 'Error',
          description: err.message,
          placement: 'bottomRight'
        });
      }
      setLoading(false);
    }).catch(err => {});
  };

  return (
    <Modal 
      className={s.appModal} 
      title="Change Password" 
      visible onCancel={onCancel}
      centered
    >
      <div className={s.modalHeader}>
        <Typography.Title level={3} className="appTitle" style={{color: '#fff'}}>
          {label.title}
        </Typography.Title>
      </div>
      <Form
        form={form}
        initialValues={{ remember: true }}
        onFinish={handleLogin}
      >
        <Row gutter={[0, 7]} style={{ padding: '30px 50px 50px' }}>
          <Col span={24}>
            <Text className={s.formLabel}>
              {label.oldPassword} <RedStar />
            </Text>
            <Form.Item
              name="oldPassword"
              rules={[
                {
                  required: true,
                  message: label.errorMsg.oldPassword,
                },
              ]}
            >
              <Input.Password
                className={s.inputStyle}
                prefix={<LockOutlined className="site-form-item-icon" />}
                placeholder={label.oldPassword}
              />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Text className={s.formLabel}>
              {label.newPassword} <RedStar />
            </Text>
            <Form.Item
              name="newPassword"
              rules={[
                {
                  required: true,
                  message: label.errorMsg.newPassword,
                },
              ]}
            >
              <Input.Password
                className={s.inputStyle}
                prefix={<LockOutlined className="site-form-item-icon" />}
                placeholder={label.newPassword}
              />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Text className={s.formLabel}>
              {label.confirmationPassword} <RedStar />
            </Text>
            <Form.Item
              name="confirmationPassword"
              rules={[
                {
                  required: true,
                  message: label.errorMsg.confirmationPassword,
                },
              ]}
            >
              <Input.Password
                className={s.inputStyle}
                prefix={<LockOutlined className="site-form-item-icon" />}
                placeholder={label.confirmationPassword}
              />
            </Form.Item>
          </Col>
          <Col span={24} style={{ marginTop: '1em' }}>
            <Button
              block
              className={s.submitButton}
              htmlType="submit"
              loading={loading}
            >
              {label.title}
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}

const RedStar = props => {
  return (
    <span style={{ color: 'red' }} {...props}>
      *
    </span>
  );
};
